import { Skeleton } from "@aircall/ds";

import { SkeletonLabelProps } from "./SkeletonLabel.decl";

export function SkeletonLabel({ h = 16, w = 200 }: SkeletonLabelProps) {
  return <Skeleton className="rounded-md" style={{ height: h, width: w }} />;
}
